/* --------------------------------------------------------------------------
	Profiles
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	var ProfileHeight = 255;

	function init() {
		if (!$('.js-profiles').length) {
			return;
		}

		Site.OnResize.push(onResize);
	}

	function onResize() {
		if ($(window).width() >= Site.MinMD) {
			ProfileHeight = 275;
		} else {
			ProfileHeight = 255;
		}

		$('.js-profile').removeClass('clipped');

		$('.js-profile-content-inner').each(function () {
			if ($(this).innerHeight() > ProfileHeight) {
				$(this).closest('.js-profile').addClass('clipped');
			}
		});
	}

	Site.OnInit.push(init);
})(jQuery, Site);
